exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.updates-tab__no-updates-msg,\n .updates-tab__add-form {\n   margin: auto;\n   padding-bottom: 30px;\n }\n\n!* .empty-timeline-message {\n   display: flex;\n   flex-direction: column;\n   text-align: center;\n   background: linear-gradient(0deg, rgba(203, 226, 230, 0.1), rgba(203, 226, 230, 0.1)), #FFFFFF;\n   border: 1px dashed rgba(203, 226, 230, 0.8);\n   box-sizing: border-box;\n   border-radius: 5px;\n   padding: 5% 15%;\n   * {\n     margin: 10px 0;\n   }\n   button {\n     margin-bottom: 2em;\n   }\n }*!\n\n .updates-tab__add-item-btn {\n   margin: 2rem auto 0;\n }*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53a1b18c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/sales/sale_details/tabs/Sales.UpdatesTab.vue
// module id = msel
// module chunks = 1